/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ConfigService {
  /**
   * 文件管理 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 计算文件大小
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileDirSize(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/dir/size',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 重命名
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileRename(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/rename',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileRemove(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/remove',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 分享
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileShare(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/share',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 上传
   * @param formData
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileUpload(formData) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/upload',
      formData: formData,
      mediaType: 'multipart/form-data'
    });
  }
  /**
   * 文件管理 - 远程下载
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileDownGet(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/down/get',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 新建文件夹
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileCreate(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/create',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 分享列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileShareList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/share/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 分享列表 - 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileShareRemove(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/share/remove',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 下发 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileDistributeNode(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/distribute/node',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 下发 - 确定
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileDistribute(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/distribute',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 下发记录 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteDistributeList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/distribute/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 下发记录 - 节点总数 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteDistributeNodeList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/distribute/node/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 下发记录 - 终止
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteDistributeAbort(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/distribute/abort',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 下发记录 - 重新下发
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteDistributeRenew(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/distribute/renew',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 下发记录 - 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteDistributeRemove(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/distribute/remove',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 命令管理 - 创建/修改 命令
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteCmdUpsert(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/cmd/upsert',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 命令管理 - 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteCmdRemove(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/cmd/remove',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 命令管理 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteCmdList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/cmd/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 命令管理 - 执行
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteCmdExecute(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/cmd/execute',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 命令管理 - 执行 - 节点列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteCmdExecuteNode(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/cmd/execute/node',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 命令管理 - 命令名称 - 命令详情
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteCmdDetail(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/cmd/detail',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 执行记录 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteExecuteList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/execute/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 执行记录 - 命令名称 - 命令详情
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteExecuteDetail(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/execute/detail',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 执行记录 - 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteExecuteRemove(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/execute/remove',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 执行记录 - 终止
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteExecuteAbort(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/execute/abort',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 执行记录 - 重新执行
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteExecuteRenew(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/execute/renew',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 默认目录
   * @returns any 成功
   * @throws ApiError
   */
  static getRemoteFilePath() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/remote/file/path'
    });
  }
  /**
   * 文件管理 - 文件名 - 读取文件
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileRead(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/read',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 文件名 - 编辑文件
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileEdit(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/edit',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 命令管理 - 节点总数 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteExecuteNodeList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/execute/node/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 文件名 - 支持修改的文件类型
   * @returns any 成功
   * @throws ApiError
   */
  static getRemoteFileReadSuffix() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/remote/file/read/suffix'
    });
  }
  /**
   * 文件管理 - 远程下载检查
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileDownCheck(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/down/check',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 上传 - 检查文件(名)是否存在
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileUploadCheck(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/upload/check',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 记录文件跳转
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileRecord(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/record',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 文件管理 - 文件跳转列表
   * @returns any 成功
   * @throws ApiError
   */
  static postRemoteFileRecordList() {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/remote/file/record/list'
    });
  }
}